module.exports = __webpack_public_path__ + "static/flight-booking-web-plp-682dacf009ceb65b22a4b671a565470e.png";